import { Axios, readAuthToken } from "../../utils/axiosMiddleware";
import { SimpleCatchError } from "../../utils/Helper";

/**
 * Adds an email to the signed-in user's own profile. Kept separate from the
 * full profile update so the payout prompt can save just this one field, and
 * separate from the change-username flow, which would replace the identifier
 * a phone-only user signs in with.
 */
export const updateUserEmail = async (email) => {
  try {
    const accessToken = readAuthToken();
    await Axios.patch(`user/${accessToken?.user_id}`, {
      email,
      user_type: accessToken?.user_type,
    });
    return true;
  } catch (e) {
    SimpleCatchError(e);
    return false;
  }
};
